/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 *
 * Manages fields, a replacement for JSON Schema.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "id",
    title: "HTML ID",
    description: "A field ID for custom javascript. Must start with a letter or underscore, followed by letters, digits, underscores, hyphens, or periods.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    tests: {
        valid: {
            must: true,
            run: function () {
                return validate({ title: "Element ID", type: "id" }, "myElement");
            }
        },
        validUnderscore: {
            must: true,
            run: function () {
                return validate({ title: "Element ID", type: "id" }, "_sidebar-nav.item1");
            }
        },
        invalidSpaces: {
            throw: "fields.id.patternMismatch",
            run: function () {
                return validate({ title: "Element ID", type: "id" }, "my element");
            }
        },
        invalidStartsWithNumber: {
            throw: "fields.id.patternMismatch",
            run: function () {
                return validate({ title: "Element ID", type: "id" }, "1element");
            }
        },
        invalidType: {
            throw: "fields.id.invalid",
            run: function () {
                return validate({ title: "Element ID", type: "id" }, 123);
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid ID",
            description: "The value must be a string.",
            template: "Expected string but received ${typeof}"
        },
        patternMismatch: {
            title: "Invalid ID Format",
            description: "The ID must start with a letter or underscore and contain only letters, digits, underscores, hyphens, or periods.",
            template: "Invalid ID: '${value}'. Must match pattern: starts with letter or underscore, then letters, digits, underscores, hyphens, or periods."
        }
    }
});

var idPattern = /^[a-zA-Z_][a-zA-Z0-9_.\-]*$/;

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ typeof: typeof value });
    }

    if (!idPattern.test(value)) {
        _.errors.patternMismatch.throw({ value: value });
    }
}
module.exports.validate = validate;
